jQuery(document).on("click", '.show_more_colors', function(e) { 
    jQuery('.flex_color_slector.half').hide();
    jQuery('.flex_color_slector.half').next().show();
});
jQuery(".flex_color_slector>a").hover(function(){
var color_name = jQuery(this).attr('color_name');

var total_images = jQuery(this).find('span.media_hover_get').length;
  jQuery('.product__grid>.product__media').addClass('hover_active');
   for(var i = 0; i < total_images; i++){
var image_url = jQuery(this).find('.media_hover_get').eq(i).attr('src');
  jQuery('.product__grid>.product__media').eq(i).css('background-image','url('+image_url+')');
   } 
    if(color_name != ""){
  jQuery('span.hover_active_color').text(color_name);
  jQuery('span.active_color').hide();
  jQuery('span.hover_active_color').show();
    }
  }, function(){
  jQuery('span.hover_active_color').hide();
  jQuery('span.active_color').show();
  jQuery('.product__grid>.product__media').removeClass('hover_active');
  jQuery('.product__grid>.product__media').css('background-image','unset');
});

if(window.outerWidth > 768) {
jQuery(".grid__swatch__container").hover(function(){
  var this_element = jQuery(this);
   setTimeout(function() {
  this_element.addClass('active');
    }, 500);
  }, function(){
   setTimeout(function() {
 this_element.removeClass('active');
    }, 500);
});
}
if(window.outerWidth < 769) {
jQuery(document).on("click", '.grid__swatch__container', function(e) { 
  jQuery(this).addClass('active');
});
}

jQuery(document).on("click", '.grid__swatch__container.active .flex_color_slector_colletions>a', function(e) { 
var link = jQuery(this).attr('href');
  location.href = link;
});